const defaultState = {
  logo_url: '',
  logo_w_url: '',
  company: '',
  phone: '',
  project_name: '',
  loading: false,
  country_iso_code: 'RU',
  enable_reassign_identifiers_by_parents: false,
  email_force_auth: false,
  e_money_enabled: false,
  e_money_max_balance: null,
};

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    /*
    *  PAYLOAD: undefined
    */
    case 'DEALER_REQUEST': {
      return { ...state, loading: true };
    }

    /*
    *  PAYLOAD: {logo_url, logo_w_url, company}
    */
    case 'DEALER_SUCCESS': {
      return { ...state, loading: false, ...action.payload };
    }

    /*
    *  PAYLOAD: {logo_url, logo_w_url, company}
    */
    case 'DEALER_FAILURE': {
      return { ...state, loading: false, ...action.payload };
    }

    default:
      return state;
  }
}
